<template>
  <footer class="footer pt-6 has-background-primary">
    <div class="columns reverse-columns is-mobile is-variable is-8 is-0-mobile is-centered is-vcentered is-multiline">
      <div class="column has-text-centered is-narrow is-full-mobile">
        <img class="img" src="../assets/logo-footer.png">
      </div>
      <div class="column is-narrow-tablet is-full-mobile">
        <div class="columns links mb-4 is-variable is-8-tablet is-0-mobile is-mobile">
          <div class="column is-narrow-tablet has-text-centered-mobile">
            <router-link to="/list/all" class="has-text-white">All Firms</router-link><br>
            <router-link to="/private-firms" class="has-text-white">Private Firms</router-link><br>
            <router-link to="/list/gov" class="has-text-white">Government</router-link><br>
            <router-link to="/list/gov" class="has-text-white">NGOs</router-link><br>
          </div>
          <div class="column is-narrow-tablet has-text-centered-mobile">
            <router-link to="/about" class="has-text-white">About</router-link><br>
            <router-link to="/FAQs" class="has-text-white">FAQs</router-link><br>
            <router-link to="/contact" class="has-text-white">Contact</router-link><br>
            <a href="https://www.ateneo.edu/law/programs/jd/apprenticeship" class="has-text-white">Directory</a><br>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterCustom"
}
</script>

<style scoped>
footer {
  overflow: hidden;
}

.img {
  width: 100%;
  max-width: 300px;
  margin-bottom: -18px;
}

.links {
  font-family: "Space Mono", monospace;
}

@media(max-width: 768px) { /* <== You can change this break point as per your  needs */
  .reverse-columns {
    flex-direction: column-reverse;
    display: flex;
  }
}
</style>